/* eslint-disable no-shadow */
import React from 'react';
import { connect } from 'react-redux';

import { setView, updateMixerTrackEffect } from '../actions';
import { mixerEffectTypes } from '../constants';
import { Eq } from './effects/Eq';
import { StereoWidth } from './effects/StereoWidth';
import { Reverb } from './effects/Reverb';

const mapStateToProps = ({
   activeInterface: {
      instrumentRack,
      view,
      compareAnswer,
      loopMode,
      loopModePlaying,
      loopModeReference,
      highlightedControls,
      suggestedValues,
   },
}) => ({
   effect:
      instrumentRack[view.instrumentIndex].mixerTrack.effects[view.effectIndex],
   referenceEffect:
      instrumentRack[view.instrumentIndex].referenceMixerTrack?.effects[
         view.effectIndex
      ],
   view,
   compareAnswer,
   loopModePlaying,
   referenceMixer: loopMode && loopModeReference,
   highlightedControls,
   suggestedValues,
});

const mapDispatchToProps = {
   setView,
   updateMixerTrackEffect,
};

const Effect = connect(
   mapStateToProps,
   mapDispatchToProps
)(
   ({
      effect,
      view,
      setView,
      updateMixerTrackEffect,
      compareAnswer,
      loopModePlaying,
      referenceMixer,
      referenceEffect,
      highlightedControls,
      suggestedValues,
   }) => (
      <div>
         {/* <button
         type="button"
         onClick={() => setView({ viewType: sequencerViewTypes.mixer })}
      >
         Close Effect
      </button> */}
         {effect.type === mixerEffectTypes.eq && (
            <Eq
               settings={effect.settings}
               referenceSettings={referenceEffect?.settings}
               instrumentIndex={view.instrumentIndex}
               effectIndex={view.effectIndex}
               compareAnswer={compareAnswer}
               referenceMixer={referenceMixer}
               onUpdate={(update) =>
                  updateMixerTrackEffect(
                     view.instrumentIndex,
                     view.effectIndex,
                     update
                  )
               }
               highlightedControls={highlightedControls}
               suggestedValues={suggestedValues}
               playing={loopModePlaying}
            />
         )}
         {effect.type === mixerEffectTypes.width && (
            <StereoWidth
               settings={effect.settings}
               onUpdate={(update) =>
                  updateMixerTrackEffect(
                     view.instrumentIndex,
                     view.effectIndex,
                     update
                  )
               }
            />
         )}
         {effect.type === mixerEffectTypes.reverb && (
            <Reverb
               settings={effect.settings}
               onUpdate={(update) =>
                  updateMixerTrackEffect(
                     view.instrumentIndex,
                     view.effectIndex,
                     update
                  )
               }
            />
         )}
      </div>
   )
);

export { Effect };
